import { twMerge } from 'tailwind-merge';

import { Colors } from '@/components/ui/types';

import { RadialProgress } from '../ui/daisy';

type PerformanceCardProps = {
  performance: number;
  title?: string;
  description?: React.ReactNode;
  radialProgressChildren?: string;
  color?: Colors;
  className?: string;
};

export function PerformanceCard({
  performance,
  title,
  description,
  radialProgressChildren,
  color = 'success',
  className,
}: PerformanceCardProps) {
  return (
    <div
      className={twMerge(
        'bg-base-100 rounded-2xl border border-base-content/10 gap-4 py-4 px-6 flex h-36 items-center',
        className,
      )}
    >
      <RadialProgress
        value={performance}
        color={color}
        children={radialProgressChildren}
        classNames={{ base: 'bg-base-200 shrink-0' }}
        aria-label={title}
      />
      <div className="flex flex-col">
        <h3 className="font-semibold text-base-content">{title}</h3>
        <p className="text-base-content/70 text-sm">{description}</p>
      </div>
    </div>
  );
}
